import React, { useState, useEffect, useContext, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import MoonDewLogoScroll from "../../assets/Logo2.svg";
import MoonDewLogo from "../../assets/Logo1.svg";
import LoginDialog from "../Addons/LoginModalBox";
import { AppContext } from "../../context/AppContext";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import eloris_img from "../../assets/slide_img_2.png";
import organic_img from "../../assets/slide_img_3.png";
import opula_img from "../../assets/slide_img_1.png";
import profil_icon from "../../assets/icons/profile_icon.png";
import cart_icon from "../../assets/icons/cart_icon.png";
import heart_icon from "../../assets/icons/wishlist_icon.png";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import KeyboardArrowRightOutlinedIcon from "@mui/icons-material/KeyboardArrowRightOutlined";
import CloseIcon from '@mui/icons-material/Close';
export default function HeaderWithDrawer() {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const [openDialog, setOpenDialog] = useState(false);
  const { setActiveTab } = useContext(AppContext);
  const isHome = location.pathname === "/";
  const isShop = location.pathname.startsWith("/shop");
  const isAbout = location.pathname === "/about";
  const [category, setCategory] = useState("Eloris");
  const [showMegaMenu, setShowMegaMenu] = useState(false);
  const toggleDrawer = () => setIsDrawerOpen(!isDrawerOpen);
  const [drawerCategory, setdrawerCategory] = useState(false);
  const [shoDrawerProcuts, setShowDrawerProducts] = useState(false);
  // Detect scroll
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  // All pages except Home should have yellow background like Shop
  const hasBackground = scrolled || isShop || isAbout || !isHome;
  const getLinkClasses = (isActive) => {
    const base = "transition-colors duration-300";
    // Transparent Home Header (initial)
    if (isHome && !hasBackground) {
      return `${base} ${isActive
        ? "text-[#3b6840] md:text-white underline underline-offset-8 decoration-2"
        : "text-[#3b6840] md:text-white hover:underline hover:underline-offset-8"
        }`;
    }
    // All other pages (Yellow background)
    return `${base} ${isActive
      ? "text-[#3b6840] underline underline-offset-8 decoration-2"
      : "text-[#3b6840] hover:underline hover:underline-offset-8"
      }`;
  };
  const products = [
    {
      category: "Eloris",
      title: "Mellow Soft Series",
      description:
        "Built for those who prefer naturally responsive comfort with balanced support.",
    },
    {
      category: "Eloris",
      title: "Ortho Back Series",
      description:
        "Built for those who prefer naturally responsive comfort with balanced support.",
    },
    {
      category: "Eloris",
      title: "Elite Memory Series",
      description:
        "Built for those who prefer naturally responsive comfort with balanced support.",
    },
    {
      category: "Eloris",
      title: "Alpha Latex Series",
      description:
        "Built for those who prefer naturally responsive comfort with balanced support.",
    },
    {
      category: "Eloris",
      title: "HyLatex Series",
      description:
        "Built for those who prefer naturally responsive comfort with balanced support.",
    },
    {
      category: "Eloris",
      title: "Bliss Memory Series",
      description:
        "Built for those who prefer naturally responsive comfort with balanced support.",
    },
    {
      category: "Organic",
      title: "Elite Memory Series",
      description:
        "Built for those who prefer naturally responsive comfort with balanced support.",
    },
    {
      category: "Organic",
      title: "Alpha Latex Series",
      description:
        "Built for those who prefer naturally responsive comfort with balanced support.",
    },
    {
      category: "Organic",
      title: "Elite Memory Series",
      description:
        "Built for those who prefer naturally responsive comfort with balanced support.",
    },
    {
      category: "Organic",
      title: "Alpha Latex Series",
      description:
        "Built for those who prefer naturally responsive comfort with balanced support.",
    },
    {
      category: "Organic",
      title: "Elite Memory Series",
      description:
        "Built for those who prefer naturally responsive comfort with balanced support.",
    },
    {
      category: "Organic",
      title: "Alpha Latex Series",
      description:
        "Built for those who prefer naturally responsive comfort with balanced support.",
    },
    {
      category: "Opula",
      title: "HyLatex Series",
      description:
        "Built for those who prefer naturally responsive comfort with balanced support.",
    },
    {
      category: "Opula",
      title: "Bliss Memory Series",
      description:
        "Built for those who prefer naturally responsive comfort with balanced support.",
    },
    {
      category: "Opula",
      title: "HyLatex Series",
      description:
        "Built for those who prefer naturally responsive comfort with balanced support.",
    },
    {
      category: "Opula",
      title: "Bliss Memory Series",
      description:
        "Built for those who prefer naturally responsive comfort with balanced support.",
    },
    {
      category: "Opula",
      title: "HyLatex Series",
      description:
        "Built for those who prefer naturally responsive comfort with balanced support.",
    },
    {
      category: "Opula",
      title: "Bliss Memory Series",
      description:
        "Built for those who prefer naturally responsive comfort with balanced support.",
    },
  ];
  const filteredProducts = products.filter(
    (product) => product.category === category,
  );
  const categorycolor = {
    Eloris: "#e8eff9",
    Organic: "#eaf4eb",
    Opula: "#fdeff4",
  };

  const sideMenuRef = useRef(null);
  useEffect(() => {
    function handleClickOutside(event) {
      // Dimension dropdown
      if (sideMenuRef.current && !sideMenuRef.current.contains(event.target)) {
        setIsDrawerOpen(false);
        setdrawerCategory(false)
        setShowDrawerProducts(false)
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  return (
    <div>
      {/* Navbar */}
      {showMegaMenu && (
        <div className="fixed top-0 z-40 w-full h-screen md:block hidden bg-black opacity-45">
          {" "}
        </div>
      )}
      <nav
        className={`fixed top-0 left-0 w-full z-50 font-lexend font-normal transition-colors duration-500 ${hasBackground
          ? "bg-[#f4e391] shadow-lg"
          : "md:bg-transparent bg-[#f4e391]"
          }`}
      >
        {/* ⭐ Yellow strip ONLY on Home + not scrolled */}
        {isHome && !scrolled && <div className="bg-[#f4e391] md:h-3"></div>}
        <div className="w-[90%] md:max-w-[80%] xl:max-w-[80rem] 3xl:max-w-[90rem] mx-auto py-2 md:py-0 flex items-center justify-between">
          {/* Logo */}
          <Link
            to="/"
            className="flex items-center md:space-x-3 md:me-4 lg:me-0 me-0 rtl:space-x-reverse"
          >
            <img
              src={isHome && !scrolled ? MoonDewLogo : MoonDewLogoScroll}
              className="md:h-auto md:block hidden md:w-auto w-[100px] bg-[#f4e391]"
              alt="Logo"
            />
            <img
              src={isHome && !scrolled ? MoonDewLogoScroll : MoonDewLogoScroll}
              className="md:hidden block md:w-auto w-[120px] bg-[#f4e391]"
              alt="Logo"
            />
          </Link>
          {/* Menu + Hamburger */}
          <div className="flex items-center lg:space-x-7 sm:space-x-2 space-x-2 xl:space-x-10">
            {/* Desktop Menu */}
            <ul className="flex xxs:text-[10px] text-sm md:text-[14px] tracking-wide font-lexend font-normal sm:space-x-3 space-x-1.5 md:space-x-6 lg:space-x-10  rtl:space-x-reverse">
              <li className="uppercase md:block hidden">
                <Link to="/" className={getLinkClasses(isHome)}>
                  Home
                </Link>
              </li>
              <li className="lg:block hidden uppercase">
                <Link to="/about" className={getLinkClasses(isAbout)}>
                  About
                </Link>
              </li>
              <li
                className="relative group md:block hidden uppercase cursor-pointer"
                onMouseEnter={() => {
                  setShowMegaMenu(true);
                }}
                onMouseLeave={() => {
                  setShowMegaMenu(false);
                }}
              >
                <Link
                  to="/eloris/mellow-soft-series"
                  className={getLinkClasses(isShop)}
                >
                  Mattresses
                </Link>
                {showMegaMenu && (
                  <div
                    onMouseLeave={() => {
                      setShowMegaMenu(false);
                      setCategory("Eloris");
                    }}
                    className="absolute md:block hidden top-full pt-10 left-0 -translate-x-2/3 lg:-translate-x-[56%] xl:-translate-x-[70%] 2xl:-translate-x-[30%] 3xl:-translate-x-[45%] lowercase z-20"
                  >
                    <div className="lg:w-[950px] w-[650px]  bg-white shadow-md flex lg:flex-row flex-col rounded-lg overflow-hidden">
                      <div className="grid-cols-[300px_1fr] flex lg:flex-col flex-row  gap-6 overflow-hidden py-6 px-7">
                        <div
                          onMouseEnter={() => setCategory("Eloris")}
                          className={`flex cursor-pointer transition-all duration-200 justify-center  items-center`}
                        >
                          <img
                            src={eloris_img}
                            alt=""
                            className="lg:w-[260px] w-44 rounded-lg"
                          />
                        </div>
                        <div
                          onMouseEnter={() => setCategory("Organic")}
                          className={`flex cursor-pointer transition-all duration-200 justify-center items-center`}
                        >
                          <img
                            src={organic_img}
                            alt=""
                            className="lg:w-[260px] w-44 rounded-lg"
                          />
                        </div>
                        <div
                          onMouseEnter={() => setCategory("Opula")}
                          className={`flex cursor-pointer transition-all duration-200 justify-center  items-center`}
                        >
                          <img
                            src={opula_img}
                            alt=""
                            className="lg:w-[260px] w-44 rounded-lg"
                          />
                        </div>
                      </div>
                      <div
                        className="lg:col-span-7 col-span-12 py-6 px-6 xl:py-7 xl:px-10 grid grid-cols-2 lg:gap-x-10 gap-x-2 xl:gap-x-14 gap-y-4"
                        style={{
                          backgroundColor: categorycolor[category],
                        }}
                      >
                        {filteredProducts.map((item, index) => (
                          <Link
                            to="/eloris/mellow-soft-series"
                            onClick={() => {
                              setShowMegaMenu(false);
                              setCategory("Eloris");
                              // setGlobalCategory(item.category)
                            }}
                            key={item.id || index}
                            className="flex flex-col cursor-pointer group/item group-item  xl:pt-1"
                          >
                            <h4 className="text-[16px] font-medium font-lexend capitalize text-[#333333] transition-all duration-200 group-hover/item:text-[#3b6840] tracking-normal">
                              {item.title}
                            </h4>
                            <p className="text-sm text-[#6d6d6d] group-hover/item:text-[#6d6d6d]/80 transition-all duration-200 font-light font-lexend xl:pt-1 leading-tight first-letter:uppercase">
                              {item.description}
                            </p>
                          </Link>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
              </li>
              <li className="2xl:block hidden uppercase">
                <Link to="/" className={getLinkClasses()}>
                  Accessories
                </Link>
              </li>
              <li className="2xl:block hidden uppercase">
                <Link to="/" className={getLinkClasses()}>
                  Kids Range
                </Link>
              </li>
              <li className="2xl:block hidden uppercase">
                <Link to="/contact-us" className={getLinkClasses()}>
                  Contact
                </Link>
              </li>
              <li>
                <button
                  onClick={() => {
                    setOpenDialog(true);
                  }}
                  className={getLinkClasses(isShop)}
                >
                  <AccountCircleIcon />
                </button>
              </li>
              <li className="">
                <Link
                  to="/profile"
                  onClick={() => {
                    setActiveTab("wishlist");
                  }}
                  className={getLinkClasses()}
                >
                  <FavoriteIcon />
                </Link>
              </li>
              <li className="">
                <Link to="/" className={getLinkClasses()}>
                  <ShoppingCartIcon />
                </Link>
              </li>
            </ul>
            {/* Hamburger Button */}
            <button
              type="button"
              className={`inline-flex items-center md:w-12 md:h-12 w-10 h-10 justify-center text-xl font-bold rounded-lg focus:outline-none 
    ${isHome && !hasBackground
                  ? "md:text-[#f4e391] text-[#2b5530]"
                  : "text-[#2b5530]"
                }`}
              onClick={() => setIsDrawerOpen(prev => !prev)}
              aria-label="Toggle drawer"
            >
              {isDrawerOpen ? (

                <CloseIcon className="md:w-10 md:h-10 w-8 h-8 "
                />

              ) : (
                <svg
                  className="md:w-8 md:h-8 w-6 h-6 "
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 17 14"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M1 1h15M1 7h15M1 13h15"
                  />
                </svg>
              )}
            </button>
          </div>
        </div>
      </nav>
      {/* Drawer */}
      <div
        ref={sideMenuRef}
        className={`fixed ${hasBackground ? "md:top-[88px] top-20" : "md:top-36 top-20"} min-h-[520px] max-h-screen  rounded-[20px] border sm:w-[95%]  xl:w-[352px] w-2/3 lg:w-1/2 border-[#588f5e]  z-50 xxs:p-2 p-4 overflow-y-auto transition-transform bg-[#3b6840] ${isDrawerOpen ? "translate-x-2" : "-translate-x-full"
          }`}
        tabIndex="-1"
        aria-labelledby="drawer-label"
      >
        {drawerCategory ? (
          <div className={`text-base px-4 font-light  text-[#f4e391] pb-3 pt-3 flex flex-col font-lexend capitalize `}>
            {shoDrawerProcuts ? (
              <div className="pb-20">
                <button
                  onClick={() => {
                    setdrawerCategory(drawerCategory);
                    setShowDrawerProducts(false);
                  }}
                  className="flex items-center justify-start border-b w-full border-[#2a582f] gap-2 mb-4 py-1.5 hover:text-white text-[#f4e391]"
                >
                  <KeyboardBackspaceIcon />
                  Back to Categories
                </button>

                {filteredProducts.map((item, index) => (
                  <Link
                    to="/eloris/mellow-soft-series"
                    onClick={() => {
                      setCategory("Eloris");
                      setdrawerCategory(false);
                      setShowDrawerProducts(false);
                      toggleDrawer()
                    }}
                    key={item.id || index}
                    className={`py-2 transition-colors flex justify-between items-center duration-300 ${isShop ? "text-[#f4e391]" : "hover:text-white"
                      }`}
                  >
                    {item.title} <ArrowForwardOutlinedIcon />
                  </Link>
                ))}
              </div>
            ) : (
              <div className=" ">
                <button
                  onClick={() => setdrawerCategory(!drawerCategory)}
                  className="flex items-center justify-start  gap-2 mb-2 py-1.5 border-b w-full border-[#2a582f] hover:text-white text-[#f4e391]"
                >
                  <KeyboardBackspaceIcon />
                  Back to Main Menu
                </button>

                <Link
                  onClick={() => {
                    setCategory("Eloris");
                    setShowDrawerProducts(true);
                  }}
                  className={`py-3  transition-colors border-b border-[#2a582f] flex justify-between hover:text-white items-center duration-300 
                    }`}
                >
                  <img
                    src={eloris_img}
                    alt=""
                    className="w-32 rounded-lg shadow-lg"
                  />{" "}
                  <ArrowForwardOutlinedIcon />
                </Link>
                <Link
                  onClick={() => {
                    setCategory("Organic");
                    setShowDrawerProducts(true);
                  }}
                  className={`py-3 transition-colors border-b border-[#2a582f] flex justify-between hover:text-white items-center duration-300
                    }`}
                >
                  <img
                    src={organic_img}
                    alt=""
                    className=" w-32 rounded-lg shadow-lg"
                  />{" "}
                  <ArrowForwardOutlinedIcon />
                </Link>
                <Link
                  onClick={() => {
                    setCategory("Opula");
                    setShowDrawerProducts(true);
                  }}
                  className={`py-3 transition-colors border-b border-[#2a582f] flex justify-between hover:text-white  items-center duration-300 
                    }`}
                >
                  <img
                    src={opula_img}
                    alt=""
                    className=" w-32 rounded-lg shadow-lg"
                  />{" "}
                  <ArrowForwardOutlinedIcon />
                </Link>
              </div>
            )}
          </div>
        ) : (
          <div>
            <div className="grid grid-cols-3 gap-3">
              <Link
                onClick={() => {
                  toggleDrawer();
                  setActiveTab("profile");
                }}
                to="/profile"
                className="flex flex-col rounded-[10px] justify-center items-center w-full py-2.5 bg-[#2a582f]"
              >
                <img src={profil_icon} alt="profile icon" />
                <span className="text-[#f4e391] text-sm font-lexend font-light mt-2">
                  Profile
                </span>
              </Link>
              <Link
                onClick={() => {
                  toggleDrawer();
                  setActiveTab("orders");
                }}
                to="/profile"
                className="flex flex-col rounded-[10px] justify-center items-center w-full py-2.5 bg-[#2a582f]"
              >
                <img src={cart_icon} alt="profile icon" />
                <span className="text-[#f4e391] text-sm font-lexend font-light mt-2">
                  Orders
                </span>
              </Link>
              <Link
                onClick={() => {
                  toggleDrawer();
                  setActiveTab("wishlist");
                }}
                to="/profile"
                className="flex flex-col rounded-[10px] justify-center items-center w-full py-2.5 bg-[#2a582f]"
              >
                <img src={heart_icon} alt="profile icon" />
                <span className="text-[#f4e391] text-sm font-lexend font-light mt-2">
                  Wishlist
                </span>
              </Link>
            </div>
            <div className="">
              <ul className="text-base px-4 font-light text-[#f4e391] pb-3 pt-3 flex flex-col font-lexend capitalize">
                <Link
                  onClick={toggleDrawer}
                  to="/"
                  className={`py-2 transition-colors flex justify-between items-center duration-300 ${isHome ? "text-[#f4e391]" : "hover:text-white"
                    }`}
                >
                  <span>HOME</span> <ArrowForwardOutlinedIcon />
                </Link>
                <Link
                  onClick={toggleDrawer}
                  to="/about"
                  className={`py-2 transition-colors flex justify-between items-center duration-300 ${isAbout ? "text-[#f4e391]" : "hover:text-white"
                    }`}
                >
                  ABOUT <ArrowForwardOutlinedIcon />
                </Link>
                <div
                  onClick={() => setdrawerCategory(!drawerCategory)}
                  className={`py-2 transition-colors uppercase flex cursor-pointer justify-between items-center duration-300 ${isShop ? "text-[#f4e391]" : "hover:text-white"
                    }`}
                >
                  Mattresses <ArrowForwardOutlinedIcon />
                </div>
                <Link
                  onClick={toggleDrawer}
                  to="/"
                  className={`py-2 transition-colors uppercase flex justify-between items-center duration-300 ${isShop ? "text-[#f4e391]" : "hover:text-white"
                    }`}
                >
                  Accessories <ArrowForwardOutlinedIcon />
                </Link>
                <Link
                  onClick={toggleDrawer}
                  to="/"
                  className={`py-2 transition-colors uppercase flex justify-between items-center duration-300 ${isShop ? "text-[#f4e391]" : "hover:text-white"
                    }`}
                >
                  kids range <ArrowForwardOutlinedIcon />
                </Link>
                <Link
                  onClick={() => {
                    toggleDrawer();
                    setActiveTab("address");
                  }}
                  to="/profile"
                  className={`py-2 xl:hidden  transition-colors uppercase flex justify-between items-center duration-300 ${isShop ? "text-[#f4e391]" : "hover:text-white"
                    }`}
                >
                  Address <ArrowForwardOutlinedIcon />
                </Link>
              </ul>
              <div className="border-t pt-3 ps-2 pe-4 font-light text-[#f4e391] font-lexend text-sm border-[#2a582f]">
                <div className="grid grid-cols-2 gap-x-3 gap-y-0.5 ">
                  <Link
                    onClick={toggleDrawer}
                    to="/certifications"
                    className={`py-1 transition-colors flex justify-between items-center duration-300 ${isShop ? "text-[#f4e391]" : "hover:text-white"
                      }`}
                  >
                    Certifications <KeyboardArrowRightOutlinedIcon />
                  </Link>
                  <Link
                    onClick={toggleDrawer}
                    to="/sap-to-sleep"
                    className={`py-1 transition-colors flex justify-between pe-2 items-center duration-300 ${isShop ? "text-[#f4e391]" : "hover:text-white"
                      }`}
                  >
                    Sap to sleep <KeyboardArrowRightOutlinedIcon />
                  </Link>
                  <Link
                    onClick={toggleDrawer}
                    to="/why-buy-latex"
                    className={`py-1 transition-colors flex justify-between items-center duration-300 ${isShop ? "text-[#f4e391]" : "hover:text-white"
                      }`}
                  >
                    Why buy Latex
                    <KeyboardArrowRightOutlinedIcon />
                  </Link>
                  <Link
                    onClick={toggleDrawer}
                    to="/8-reason-to-choose"
                    className={`py-1 transition-colors flex justify-between pe-2 items-center duration-300 ${isShop ? "text-[#f4e391]" : "hover:text-white"
                      }`}
                  >
                    8 Reason
                    <KeyboardArrowRightOutlinedIcon />
                  </Link>
                  <Link
                    onClick={toggleDrawer}
                    to="/mattress-guide"
                    className={`py-1 transition-colors flex justify-between items-center duration-300 ${isShop ? "text-[#f4e391]" : "hover:text-white"
                      }`}
                  >
                    Mattress Guide <KeyboardArrowRightOutlinedIcon />
                  </Link>
                  <Link
                    onClick={toggleDrawer}
                    to="/contact-us"
                    className={`py-1 transition-colors flex justify-between pe-2 items-center duration-300 ${isShop ? "text-[#f4e391]" : "hover:text-white"
                      }`}
                  >
                    Contact <KeyboardArrowRightOutlinedIcon />
                  </Link>
                </div>
              </div>

              <button
                onClick={() => {
                  setOpenDialog(true);
                  toggleDrawer();
                }}
                className="bg-[#f4e391] font-lexend mt-4 rounded-2xl border-2 border-[#f4e391]  w-full py-2 hover:bg-[#f4e391] text-[#3b6840] transition-colors text-lg uppercase font-medium duration-300"
              >
                sign up
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Overlay */}
      {isDrawerOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-45 z-30"
          onClick={toggleDrawer}
        />
      )}
      <LoginDialog open={openDialog} handleClose={() => setOpenDialog(false)} />
    </div>
  );
}
